import React, { JSX } from 'react';
import {
  Field,
  Image,
  ImageField,
  Link,
  LinkField,
  Text,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { formatLocationUrl } from 'assets/utils/formatUrl';
import Icons from 'components/atoms/Icons';
import { classNames } from 'assets/utils/helper';
import { getMarginSize } from 'assets/utils/getMarginSize';
import { StyleguideComponentProps } from 'lib/component-props';

type LocationCollection = {
  id: string;
  url: string;
  name: string;
  fields: {
    Street1: Field<string>;
    FeaturedStreet2: Field<string>;
    City: Field<string>;
    LocationId: Field<string>;
    State: Field<string>;
    Zip: Field<string>;
    LocationImage: ImageField;
    FeaturedLocationLink: {
      value: string;
    };
    LocationName: Field<string>;
  };
};
type FeaturedLocationsProps = StyleguideComponentProps & {
  fields: {
    MarginSize: {
      fields: {
        heading: {
          value: string;
        };
      };
    };
    Title: Field<string>;
    BaseVertical: {
      value: boolean;
    };
    Locations: Array<LocationCollection>;
    BaseViewMoreLink: LinkField;
  };
};

const FeaturedLocations = (props: FeaturedLocationsProps): JSX.Element => {
  const marginSize = getMarginSize(
    props?.fields?.MarginSize?.fields?.heading?.value
  );
  const { fields } = props;
  if (fields == undefined) {
    return <div>Data source is not defined</div>;
  }

  return (
    <div
      className={classNames('overhauled', marginSize)}
      id={`featured-locations-${props.rendering?.uid}`}
    >
      <div className="featured-list locations jss-inner-container">
        {fields?.Title?.value && (
          <h2 className="title">{fields?.Title?.value}</h2>
        )}
        <div className={`list-inner`}>
          {fields?.Locations &&
            fields?.Locations?.length > 0 &&
            fields?.Locations.map(({ fields, id, name }) => (
              <a
                href={formatLocationUrl(fields.LocationId.value, name)}
                key={id}
                className="featured-item bg-secondary"
              >
                <div className="content-container">
                  <div
                    className="address"
                    itemProp="hospitalAffiliation"
                    itemType="http://schema.org/Hospital"
                  >
                    {fields?.City?.value && fields?.State?.value && (
                      <p className="item-title">
                        <Text field={fields.City} />,{' '}
                        <Text field={fields.State} />
                      </p>
                    )}

                    <div className="address-details">
                      <svg className="icon icon-location">
                        <Icons id="icon-location" />
                      </svg>
                      <p
                        className="item-subtitle"
                        itemProp="address"
                        itemScope
                        itemType="http://schema.org/PostalAddress"
                      >
                        {fields?.Street1 && <Text field={fields.Street1} />}
                      </p>
                    </div>
                    <p className="item-name" itemProp="hospitalAffiliation">
                      <Text field={fields.LocationName} />
                    </p>
                  </div>
                </div>

                <div className="item-image">
                  {fields?.LocationImage?.value?.src ? (
                    <Image field={fields?.LocationImage} />
                  ) : (
                    <img
                      alt={`image-${id}`}
                      src="https://osf-p-001.sitecorecontenthub.cloud/api/public/content/placeholder-location-transparent"
                    />
                  )}
                </div>
              </a>
            ))}
        </div>
        {props.fields?.BaseViewMoreLink?.value?.href && (
          <div className="view-more">
            <Link
              className="btn-primary"
              field={props.fields?.BaseViewMoreLink}
            />
            <div className="divider"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FeaturedLocations;
